import { collection, deleteDoc, doc, query, Timestamp, updateDoc, where } from "firebase/firestore"
import { CalendarDate, DateFormatter, getLocalTimeZone } from "@internationalized/date"
import { getDate } from "date-fns"

import SparkMD5 from "spark-md5"
import { createColumnHelper } from "@tanstack/vue-table"

export function randomInt(min: number, max: number): number {
	return Math.floor(Math.random() * (max - min + 1)) + min
}

export function randomFrom<T>(array: T[]): T {
	return array[Math.floor(Math.random() * array.length)]!
}

export function encodeBase64(value: string): string {
	return Buffer.from(value, "utf8").toString("base64")
}

export function decodeBase64(value: string): string {
	try {
		return Buffer.from(value, "base64").toString("utf8")
	} catch (error) {
		console.log("decodeBase64", value, error)
		return "#/na"
	}
}

export function isInt(value) {
	return (
		!isNaN(value) &&
		(function (x) {
			return (x | 0) === x
		})(parseFloat(value))
	)
}

export function isArray(varCheck: any) {
	return typeof varCheck !== "undefined" && Object.getPrototypeOf(Object(varCheck)) === Object.getPrototypeOf([])
}
export function isNotArrayOrEmpty(varCheck: any) {
	// console.log(varCheck, varCheck?.length)
	if (isArray(varCheck)) return varCheck.length === 0

	return true
}

export function compareObjects(obj1, obj2) {
	const mutableObject1 = { ...{}, ...obj1 } // Object.assign({}, obj1)
	const mutableObject2 = { ...{}, ...obj2 } // Object.assign({}, obj2)

	// console.log("mergeObjects", mutableObject1, mutableObject2)

	return false
}

export function levelCompare(lvl1, lvl2) {
	if (lvl1 == lvl2) return 0
	const lvl1_split = lvl1.split("_")
	const lvl2_split = lvl2.split("_")
	const maxComp = Math.min(lvl1_split.length, lvl2_split.length)

	// let compareLevels = 1
	for (let i = 0; i < maxComp; i++) {
		if (lvl1_split[i] !== lvl2_split[i]) {
			const lvl1_split_val = (lvl1_split[i] + "").padStart(5, "0")
			const lvl2_split_val = (lvl2_split[i] + "").padStart(5, "0")
			return lvl1_split_val.localeCompare(lvl2_split_val)
			// return parseInt(lvl1_split[i]) > parseInt(lvl2_split[i]) ? -1 : 1
		}

		// console.log(lvl1_split_val, lvl2_split_val, lvl1_split_val.localeCompare(lvl2_split_val))
	}
	return lvl1_split.length > lvl2_split.length ? 1 : -1

	// return boolLarger ? 1 : -1
}

export function getObjectString(obj1) {
	// const mutableObject1 = { ...{}, ...obj1 } // Object.assign({}, obj1)
	var out = ""
	for (let [key, value] of Object.entries(obj1)) {
		if (!(key === "updates_history") && !(key === "id")) {
			out = out + "|" + JSON.stringify(value)
		} else {
			// console.log("getObjectHash IGONER", key, value)
		}
	}
	// return SparkMD5.hash(obj1)
	// console.log("mergeObjects", mutableObject1, mutableObject2)

	return out
}
export function getObjectHash(obj1, what_keys: any[], ignored_keys: any[]) {
	// console.log(obj1)
	// const mutableObject1 = { ...{}, ...obj1 } // Object.assign({}, obj1)
	var spark = new SparkMD5()
	for (let key of what_keys.sort()) {
		if (ignored_keys.indexOf(key) === -1) {
			if (obj1[key] !== undefined && obj1[key] !== null) {
				if (isObject(obj1[key])) {
					spark.append(getObjectHash(obj1[key], Object.keys(obj1[key]), ignored_keys))
				} else {
					spark.append(obj1[key])
				}
			} else {
				spark.append(key)
			}
		} else {
			// console.log("getObjectHash IGONER", key, value)
		}
	}
	// return SparkMD5.hash(obj1)
	// console.log("mergeObjects", mutableObject1, mutableObject2)

	return spark.end()
}

export function mergeObjects(obj1, obj2) {
	// return obj1 & obj2

	// return { ...{}, ...obj1, ...obj2 }

	const mutableObject1 = structuredClone(obj1)
	const mutableObject2 = structuredClone(obj2)
	return { ...{}, ...mutableObject1, ...mutableObject2 }
	// return mergeFunction(mutableObject1, mutableObject2)
}

export const mergeFunction = (obj1, obj2) => {
	// console.log(obj1, obj2)
	const out = <tsAppendableObj>{}
	for (const key1 of Object.keys(obj1)) {
		if (Object.keys(obj2).indexOf(key1) > -1) {
			out[key1] = obj2[key1]
		} else {
			out[key1] = obj1[key1]
		}
	}
	return out
}

export const getParentLevel = (level: string) => {
	const levels = level.split("_")
	if (levels && levels instanceof Array) {
		if (levels.length > 0) {
			console.log(levels, levels.slice(0, -1))
			return levels.slice(0, -1).join("_")
		}
	}
	return ""
}
export const getParentLevels = (level: string) => {
	const levels = level.split("_")
	const out = []
	if (levels && levels instanceof Array) {
		if (levels.length > 0) {
			for (let i = levels.length - 1; i > 0; i--) {
				out.push(levels.slice(0, -i).join("_"))
			}
		}
	}
	return out
}

export const columnHelper = createColumnHelper()

export function remapValues(header_key_raw: string, valzz: any, headers_map: tsAppendableObj) {
	// console.log(header_key, valzz, headers_map)
	const header_key = header_key_raw.replace(/\r\n|\n/g, "\\n")
	const header_key_new = headers_map[header_key]
	if (!header_key_new) {
		// console.log({ mapped_header: "undefined_" + header_key, mapped_val: valzz }, headers_map)
		return { mapped_header: "undefined_header@" + header_key, mapped_val: valzz }
	}
	const out = <tsAppendableObj>{ mapped_header: header_key_new.map_to }

	if (header_key_new.map_list) {
		// console.log(header_key_new.map_list)
		if (header_key_new.map_list[valzz]) {
			out.mapped_val = header_key_new.map_list[valzz]
		} else {
			out.mapped_val = "undefined_list_value@" + valzz
		}
	} else {
		out.mapped_val = valzz
	}
	// console.log(header_key, valzz, headers_map, out)
	return out
}

export function getObjByPath(obj: any, path: string, path_separator: string = ".", defaut_value: any) {
	// console.log("getObjByPath", path, path.split(path_separator))
	return path.split(path_separator).reduce((o, key) => {
		// console.log(typeof key, key)
		// if (isNumber(key)) key = parseInt(key)
		// console.log(typeof key, key)

		if (o && typeof o[key] !== "undefined") {
			return o[key]
		} else {
			return defaut_value
		}
	}, obj)
}

export function setObjByPath(
	objIn: any,

	val_new: any,
	val_path: string,
	path_separator: string = ".",
	current_path: string = "",
): any {
	// console.log("setObjByPath", objIn, path, val_new, path_separator)

	if (isObject(objIn)) {
		const objOut = {}
		for (const key of Object.keys(objIn)) {
			const new_current_path = current_path + path_separator + key
			// console.log(val_path, new_current_path)

			objOut[key] =
				val_path === new_current_path
					? val_new
					: setObjByPath(objIn[key], val_new, val_path, path_separator, new_current_path)
		}
		return objOut
	} else if (isArray(objIn)) {
		const objOut = []
		for (const index in objIn) {
			const new_current_path = current_path + path_separator + index
			// console.log(val_path, new_current_path)
			objOut.push(
				val_path === new_current_path
					? val_new
					: setObjByPath(objIn[index], val_new, val_path, path_separator, new_current_path),
			)
		}
		return objOut
	} else {
		return objIn
	}
}

export function object_equals(x, y) {
	if (x === y) return true
	// if both x and y are null or undefined and exactly the same

	if (!(x instanceof Object) || !(y instanceof Object)) return false
	// if they are not strictly equal, they both need to be Objects

	if (x.constructor !== y.constructor) return false
	// they must have the exact same prototype chain, the closest we can do is
	// test there constructor.

	for (var p in x) {
		if (!x.hasOwnProperty(p)) continue
		// other properties were tested using x.constructor === y.constructor

		if (!y.hasOwnProperty(p)) return false
		// allows to compare x[ p ] and y[ p ] when set to undefined

		if (x[p] === y[p]) continue
		// if they have the same strict value or identity then they are equal

		if (typeof x[p] !== "object") return false
		// Numbers, Strings, Functions, Booleans must be strictly equal

		if (!object_equals(x[p], y[p])) return false
		// Objects and Arrays must be tested recursively
	}

	for (p in y) if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false
	// allows x[ p ] to be set to undefined

	return true
}

// export function getObjByPath(obj: any, path: string, path_separator: string = ".", defaut_value: any) {
// 	// console.log("getObjByPath", path, path.split(path_separator))
// 	return path
// 		.split(path_separator)
// 		.reduce((o, key) => (o && typeof o[key] !== "undefined" ? o[key] : defaut_value), obj)
// }

export function getFirstArrayPath(path: string, path_separator: string = "."): any {
	// console.log("getObjByPath", path, path.split(path_separator))
	const paths = path.split(path_separator)
	const out = []
	for (let i = 0; i < paths.length; i++) {
		if (isInt(paths[i])) break
		out.push(paths[i])
	}
	// console.log("getObjByPathArray", paths, out)
	return out.join(path_separator)
}

// export async function getApiCall(strApiCall: string, method: any, lazy: boolean = false): any {
// 	const res = await $fetch(strApiCall, {
// 		lazy: lazy,
// 		method: method,
// 		// body: content,
// 		// headers: { 'X-FIGMA-TOKEN': context.value.figma_api_key }
// 	})
// 	// If you care about a response:
// 	if (res) {
// 		if (!res.valid) {
// 			console.log("bad api response", strApiCall, res)
// 		}
// 		return res
// 	}
// }

export function getRandomIndex(max: number, _prefix?: string): any {
	return _prefix ? _prefix + Math.floor(Math.random() * max) : Math.floor(Math.random() * max)
}

export const setFirebaseFilters = async (filters: any, key: string, table: string, key_data?: string) => {
	const db = useFirestore()
	// console.log("setFirebaseFilters 1111", unproxify(filters), key, table)

	// const key = holders_vuefire[table].value.id
	const db_ref = doc(db, table, key)
	// const filterss =

	// if (payload.filters["dates"]._is_set) delete payload.filters["dates"]._is_set

	await updateDoc(db_ref, { filters: unproxify(filters) })
	// await updateDoc(db_ref, { filters: unproxify(holders_vuefire[table].value["filters"]) })

	// const db_ref = doc(db, "langs", key)
}

export const setFirebaseEntry = async (table: string, key_data: string, payload_data: any) => {
	const db = useFirestore()

	if (key_data) {
		// console.log("setFirebaseEntry", table, key_data, payload_data)
		if (payload_data && !payload_data["edit_date"]) payload_data["edit_date"] = Timestamp.now()

		const db_ref = doc(db, table, key_data)
		if (payload_data) {
			await updateDoc(db_ref, payload_data)
		}
	}

	// const db_ref = doc(db, "langs", key)
}
export const deleteFirebaseEntry = async (table: string, key_data: string) => {
	const db = useFirestore()

	if (key_data) {
		// console.log("setFirebaseEntry", table, key_data, payload_data)

		const db_ref = doc(db, table, key_data)

		await deleteDoc(db_ref)
	}

	// const db_ref = doc(db, "langs", key)
}

export const setQPar = (context_holder: any, par_name: string) => {
	console.log("setQPar", par_name, context_holder[par_name])
	const route = useRoute()
	const router = useRouter()
	localStorage.setItem(par_name, JSON.stringify(context_holder[par_name]))
	router.push({ query: { ...route.query, [par_name]: context_holder[par_name] }, hash: route.hash })
}

export const setPathPar = (context_holder: any, par_name: string, par_pos: number) => {
	console.log("setPathPar", par_name, context_holder[par_name])
	const route = useRoute()
	const router = useRouter()
	localStorage.setItem(par_name, JSON.stringify(context_holder[par_name]))
	// console.log(route.params[par_name])
	router.replace({ params: { ...route.params, [par_name]: context_holder[par_name] } })
	// router.push({ params: { [par_name]: context_holder[par_name] } })
	// router.push({ query: { ...route.query, [par_name]: context_holder[par_name] }, hash: route.hash })
}

export const getQParDef = (par_name: string, defaultValue?: unknown) => {
	console.log("getQParDef", par_name, defaultValue)

	const route = useRoute()
	// const router = useRouter()
	if (route.query && route.query[par_name]) {
		return route.query[par_name]
	} else {
		const local_val = localStorage.getItem(par_name)
		if (local_val) return local_val
	}
	return defaultValue
}

export const getPathParDef = (par_name: string, defaultValue?: unknown) => {
	console.log("getPathParDef", par_name, defaultValue)

	const route = useRoute()
	// const router = useRouter()
	if (route.params && route.params[par_name]) {
		return route.params[par_name]
	} else {
		const local_val = localStorage.getItem(par_name)
		if (local_val) return local_val
	}
	return defaultValue
}

export const getSetQPar = async (context_holder: any, par_name: string, par_val?: unknown) => {
	// console.log('getSetQPar init', context_holder, par_name, par_val)
	const route = useRoute()
	const router = useRouter()
	if (par_val !== undefined) {
		context_holder[par_name] = par_val
		localStorage.setItem(par_name, JSON.stringify(context_holder[par_name]))
		router.push({ query: { ...route.query, [par_name]: context_holder[par_name] } })
		// console.log("getSetQPar", " override ", par_name, par_val)
	} else if (route.query[par_name]) {
		context_holder[par_name] = qToObj(route.query[par_name])
		localStorage.setItem(par_name, JSON.stringify(context_holder[par_name]))
		// console.log("getSetQPar", " querry ", par_name, context_holder[par_name] ? context_holder[par_name] : "")
	} else {
		let local_val = localStorage.getItem(par_name)
		// console.log("getSetQPar", " localstorage ", local_val)
		if (local_val && local_val !== "undefined") {
			local_val = qToObj(JSON.parse('{"val":' + local_val + "}").val)
			context_holder[par_name] = local_val
			await router.push({ query: { ...route.query, [par_name]: context_holder[par_name] } })
			// console.log("getSetQPar", " localstorage ", par_name, context_holder[par_name])
		} else {
			localStorage.setItem(par_name, JSON.stringify(context_holder[par_name]))
			router.push({ query: { ...route.query, [par_name]: context_holder[par_name] } })
			// console.log("getSetQPar", " default ", par_name, context_holder[par_name])
		}
	}
}

export const getSetPathPar = async (context_holder: any, par_name: string, par_val?: unknown, par_redirect?: any) => {
	// console.log("getSetPathPar init", context_holder, par_name, par_val, par_redirect)
	const route = useRoute()
	const router = useRouter()
	if (par_val !== undefined) {
		context_holder[par_name] = par_val
		localStorage.setItem(par_name, JSON.stringify(context_holder[par_name]))
		// console.log("getSetPathPar", " override ", par_name, par_val, par_redirect)

		if (route.params && route.params[par_name]) {
			await router.push({ params: { ...route.params, [par_name]: context_holder[par_name] } })
		} else if (par_redirect !== "") {
			// console.log("gigigigii", par_redirect)
			await navigateTo(par_redirect)
		}
	} else if (route.params[par_name]) {
		context_holder[par_name] = qToObj(route.params[par_name])
		localStorage.setItem(par_name, JSON.stringify(context_holder[par_name]))
		// console.log("getSetPathPar", " querry ", par_name, context_holder[par_name] ? context_holder[par_name] : "")
	} else {
		let local_val = localStorage.getItem(par_name)
		// console.log("getSetPathPar", " localstorage ", local_val)

		if (local_val && local_val !== undefined) {
			local_val = qToObj(JSON.parse('{"val":' + local_val + "}").val)
			context_holder[par_name] = local_val
			// console.log({ params: { ...{}, [par_name]: context_holder[par_name] } })
			if (route.params && route.params[par_name]) {
				await router.push({ params: { ...route.params, [par_name]: context_holder[par_name] } })
			} else if (par_redirect !== undefined) {
				// console.log(route.params[par_name])
				await navigateTo(par_redirect)
			}
			// console.log("getSetPathPar", " localstorage ", par_name, context_holder[par_name])
		} else {
			localStorage.setItem(par_name, JSON.stringify(context_holder[par_name]))
			if (route.params && route.params[par_name]) {
				await router.push({ params: { ...route.params, [par_name]: context_holder[par_name] } })
			} else if (par_redirect !== undefined) {
				await navigateTo(par_redirect)
			} else {
				await router.push({ params: { ...route.params, [par_name]: context_holder[par_name] } })
			}
			// console.log("getSetPathPar", " default ", par_name, context_holder[par_name])
		}
	}
}

// export function objToQ(var_val: unknown) {

// }

export function qToObj(var_val: unknown) {
	// console.log(var_val)
	switch (true) {
		case "undefined" == var_val:
		case "" == var_val:
			return ""
			break
		case "0" == var_val:
			return 0
			break
		case "true" == var_val:
			return true
			break
		case "false" == var_val:
			return false
			break
		case isNumber("" + var_val):
			return Number(var_val)
			break
			// case ("" + var_val).startsWith("{"):
			// case ("" + var_val).startsWith("["):
			// return JSON.parse("" + var_val)
			// if(obj_out["calendar"])

			break
		case isValidDate(var_val):
			return getDateFromIsoString("" + var_val)
			break
		case new RegExp("^\\d{4}\\-(0[1-9]|1[012])\\-(0[1-9]|[12][0-9]|3[01])$").test("" + var_val):
			return getCaledarDateFromString("" + var_val)
			break
		default:
			return var_val
	}
}

export function typeName(obj) {
	// console.log(obj.constructor.name, Object.prototype.toString.call(obj))
	const type_out = Object.prototype.toString.call(obj).slice(8, -1)
	if (type_out === "Object") return obj.constructor.name
	return type_out
}

export function checkIsoDate(value: string) {
	/**
	 * RegExp to test a string for a ISO 8601 Date spec
	 *  YYYY
	 *  YYYY-MM
	 *  YYYY-MM-DD
	 *  YYYY-MM-DDThh:mmTZD
	 *  YYYY-MM-DDThh:mm:ssTZD
	 *  YYYY-MM-DDThh:mm:ss.sTZD
	 * @see: https://www.w3.org/TR/NOTE-datetime
	 * @type {RegExp}
	 */
	// const ISO_8601: RegExp = /^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/i

	/**
	 * RegExp to test a string for a full ISO 8601 Date
	 * Does not do any sort of date validation, only checks if the string is according to the ISO 8601 spec.
	 *  YYYY-MM-DDThh:mm:ss
	 *  YYYY-MM-DDThh:mm:ssTZD
	 *  YYYY-MM-DDThh:mm:ss.sTZD
	 * @see: https://www.w3.org/TR/NOTE-datetime
	 * @type {RegExp}
	 */
	const ISO_8601_FULL: RegExp = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i

	return ISO_8601_FULL.test(value)
}

export function mapExcelToVal(value: unknown, type: string) {
	if (value === undefined) {
		return { type: type, data: "" }
	} else {
		switch (type) {
			case "Object":
				return {
					type: type,
					data: value
						? JSON.parse(
								"" + value,
								(key, value) => (typeof value === "string" ? (checkIsoDate(value) ? new Date(value) : value) : value), // return everything else unchanged
							)
						: null,
				}
				break
			// objects[uid][headers[j]]=JSON.parse(JSON.stringify(JSON.parse(''+data[i][j])));

			// console.log('here objects',headers[j],typeof value, value,typeof objects[uid][headers[j]],objects[uid][headers[j]])
			case "String":
				return { type: type, data: "" + value }
				break
			case "DateTime":
				return { type: type, data: value ? getDateFromIsoString("" + value) : "" }
				break
			case "ExcelDateTime":
				return { type: type, data: value ? getDateFromSerialValue(value) : "" }
				break
			// console.log('here String or DateTime',headers[j],typeof value, value,typeof objects[uid][headers[j]],objects[uid][headers[j]])
			case "Key":
				return { type: type, data: "" + value }
				break
			//  console.log('here other',headers[j],typeof value, value,typeof objects[uid][headers[j]],objects[uid][headers[j]])
			case "Boolean":
				// console.log("here Boolean", type, typeof value, value, value === "TRUE" ? true : value === "FALSE" ? false : value === "1" || value === 1 ? true : value === "0" || value === 0 ? false : "")
				return {
					type: type,
					data:
						value === "TRUE"
							? true
							: value === "FALSE"
								? false
								: value === "1" || value === 1
									? true
									: value === "0" || value === 0
										? false
										: "",
				}
				break

			case "TimeStamp":
				return { type: type, data: Timestamp.fromDate(new Date("" + value)) }
				break
			//  console.log('here other',headers[j],typeof value, value,typeof objects[uid][headers[j]],objects[uid][headers[j]])
			case "Collection":
				return { type: type, data: value ? JSON.parse("" + value) : null }
				break
			//  console.log('here other',headers[j],typeof value, value,typeof objects[uid][headers[j]],objects[uid][headers[j]])
			case "Value":
				return { type: type, data: textToValue(value) }
				break
			//  console.log('here other',headers[j],typeof value, value,typeof objects[uid][headers[j]],objects[uid][headers[j]])
			default:
				return { type: type, data: value }
				break
			//  console.log('here other',headers[j],typeof value, value,typeof objects[uid][headers[j]],objects[uid][headers[j]])
		}
	}
}

export function getCaledarDateFromString(value?: string) {
	const datz = value?.split("-")
	// console.log(datz)
	return new CalendarDate(parseInt(datz[0]), parseInt(datz[1]), parseInt(datz[2]))
}

export function dateDiffInYears(dateold: Date, datenew: Date) {
	const ynew = datenew.getFullYear()
	const mnew = datenew.getMonth()
	const dnew = datenew.getDate()
	const yold = dateold.getFullYear()
	const mold = dateold.getMonth()
	const dold = dateold.getDate()
	let diff = ynew - yold
	if (mold > mnew) diff--
	else {
		if (mold == mnew) {
			if (dold > dnew) diff--
		}
	}
	return diff
}

export function deltaDate(input: Date, days: number, months: number, years: number) {
	return new Date(
		input.getFullYear() + years,
		input.getMonth() + months,
		Math.min(input.getDate() + days, new Date(input.getFullYear() + years, input.getMonth() + months + 1, 0).getDate()),
	)
}

// export function getDateTimeValFromCalendarDate(val: CalendarDate, day_offset?: number) {
// 	if (!val) return null
// 	console.log("getDateTimeValFromCalendarDate", val)
// 	// console.log(getLocalTimeZone(), valuez, valuez, valuez.toDate("Europe/London"))
// 	// console.log(getLocalTimeZone())
// 	const out = val.toDate("Europe/London")
// 	if (day_offset) return addDays(out, day_offset) //(getLocalTimeZone()) "Europe/Madrid"
// 	return out
// }
export function getDateTimeValFromCalendarDateObj(val: any, day_offset?: number) {
	if (!val) return null
	// console.log("getDateTimeValFromCalendarDateObj", val)
	const gg = <CalendarDate>getCalendarDateFromCalendarObj(val)
	// console.log(getLocalTimeZone(), valuez, valuez, valuez.toDate("Europe/London"))
	// console.log(getLocalTimeZone())
	const out = gg.toDate("Europe/London")
	if (day_offset) return addDays(out, day_offset) //(getLocalTimeZone()) "Europe/Madrid"
	return out
}

export function addDays(date, days) {
	const result = new Date(date)
	result.setDate(result.getDate() + days)
	return result
}

export function getCalendarDateFromCalendarObj(val?: any) {
	if (!val) return null
	return new CalendarDate(val.year, val.month, val.day)
}

export function isValidDate(d) {
	return d && Object.prototype.toString.call(d) === "[object Date]" && !isNaN(d)
}

export function isNumber(val?: string | number): boolean {
	// if (!val) return false
	return val != null && val !== "" && !isNaN(Number(val.toString()))
}

export function isObject(val: unknown) {
	// if (!val) return false
	return typeof val === "object" && !Array.isArray(val) && val !== null
}

export function getDate2(dateVal) {
	return new Date(dateVal).toLocaleString("en-US", {
		day: "numeric",
		month: "short",
		hour: "2-digit",
		minute: "2-digit",
		hour12: false,
	})
}

export function getIsoDateFromDateVal(d: any) {
	if (!d) return null
	// console.log("getDateFromIsoString", val, d)
	return d.toISOString()
}

export function getDateFromIsoString(val: string) {
	if (!val) return null
	const d = new Date(val)
	// console.log("getDateFromIsoString", val, d)
	return d
}

export function getTimeStampFromSerialValue(val: string) {
	if (!val) return null
	const d = new Date(val)

	// console.log("getDateFromIsoString", val, d)
	return Timestamp.fromDate(d)
}

export function getDateFromSerialValue(serial: number) {
	if (!serial) return null

	// console.log("getDateFromIsoString", val, d)

	const utc_days = Math.floor(serial - 25569)
	const utc_value = utc_days * 86400
	const date_info = new Date(utc_value * 1000)

	const fractional_day = serial - Math.floor(serial) + 0.0000001

	let total_seconds = Math.floor(86400 * fractional_day)

	const seconds = total_seconds % 60

	total_seconds -= seconds

	const hours = Math.floor(total_seconds / (60 * 60))
	const minutes = Math.floor(total_seconds / 60) % 60

	return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds)
}

export function getDateFromSeconds(seconds: number) {
	return new Date(seconds)
}

export function getDateTimeFromSeconds(seconds: number) {
	const d = new Date(seconds)
	return getDateShort(d) + " " + getTimeShort(d)
}

export function getCalendarDateFromTimestamp(val: Timestamp) {
	if (!val) return null
	const d = new Date(val.seconds * 1000)
	return new CalendarDate(d.getFullYear(), d.getMonth() + 1, d.getDate())
}

export function getDateValueFromTimestamp(val: any) {
	if (!val) return null

	if (val.seconds) {
		return new Date(val.seconds * 1000)
	} else if (val._seconds) {
		return new Date(val._seconds * 1000)
	}
}
export function getDateTimeFromTimestamp(val: Timestamp) {
	if (!val) return null
	const d = getDateValueFromTimestamp(val)
	return d ? getDateShort(d) + " " + getTimeShort(d) : null
}

export function getDateShortFromTimestamp(val: Timestamp) {
	if (!val) return null
	const d = getDateValueFromTimestamp(val)
	return d ? getDateShort(d) : null
}

export function getDateShorterFromTimestamp(val: Timestamp) {
	if (!val) return null
	const d = getDateValueFromTimestamp(val)
	return d ? getDateShorter(d) : null //("0" + d.getDate()).slice(-2) + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + " '" + (d.getFullYear() + "").slice(-2)
}

export function getTimeShortFromTimestamp(val: Timestamp) {
	if (!val) return null
	const d = getDateValueFromTimestamp(val)
	return d ? getTimeShort(d) : null
}

export function convertFirestoreTimestampFields(obj: any): any {
	const out: any = {}
	if (Array.isArray(obj)) {
		return obj.map(convertFirestoreTimestampFields)
	}
	if (obj && typeof obj === "object") {
		if (typeof obj.seconds === "number" && typeof obj.nanoseconds === "number") {
			return getDateValueFromTimestamp(obj)
		}

		for (const key in obj) {
			out[key] = convertFirestoreTimestampFields(obj[key])
		}
		return out
	}
	return obj
}

export function getDateShorter(d: Date) {
	if (!d) return null
	return (
		"'" +
		(d.getFullYear() + "").slice(-2) +
		"-" +
		("0" + d.getDate()).slice(-2) +
		"-" +
		("0" + (d.getMonth() + 1)).slice(-2)
	)
	// ("0" + d.getDate()).slice(-2) + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + " '" + (d.getFullYear() + "").slice(-2)
}

export function getDateShort(d: Date) {
	if (!d) return null
	return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2)
}
export function getTimeShort(d: Date) {
	if (!d) return null
	return ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2)
}

export function textToValue(val: unknown) {
	if (!val) return 0
	if (("" + val).trim() == "-") return 0
	const out = ("" + val)
		.trim()
		.replace(/[^\d\-.,]/g, "") // Basic sanitization. Allows '-' for negative numbers
		.replace(/,/g, ".") // Change all commas to periods
		.replace(/\.(?=.*\.)/g, "") // Remove all periods except the last one
	// console.log(out)
	return parseFloat(out)
}

export function getSum(array: number[]) {
	let sum = 0
	for (let i = 0; i < array.length; i++) {
		if (array[i]) sum += array[i]
	}
	return sum
}

export function roundNumber(num, scale) {
	if (!("" + num).includes("e")) {
		return +(Math.round(num + "e+" + scale) + "e-" + scale)
	} else {
		const arr = ("" + num).split("e")
		let sig = ""
		if (+arr[1] + scale > 0) {
			sig = "+"
		}
		return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale)
	}
}

export function unproxify(val: any): any {
	if (val instanceof Array) return val.map(unproxify)
	if (val instanceof Object) {
		// if (val["calendar"]) return getDateTimeValFromCalendarDateObj(val)
		return Object.fromEntries(Object.entries(Object.assign({}, val)).map(([k, v]) => [k, unproxify(v)]))
	}

	return val
}

export function sleep(ms: number) {
	return new Promise((resolve) => {
		setTimeout(resolve, ms)
	})
}

export function checkEmailbyRegex(val: any): any {
	const email_regex =
		// eslint-disable-next-line no-control-regex
		/(?:[a-z0-9!#$%&'*+\x2f=?^_`\x7b-\x7d~\x2d]+(?:\.[a-z0-9!#$%&'*+\x2f=?^_`\x7b-\x7d~\x2d]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9\x2d]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9\x2d]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9\x2d]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

	return email_regex.test(val)
}

export function sanitizeFileName(name: string) {
	return name
		.normalize("NFKD")
		.replace(/[\u0300-\u036f]/g, "")
		.replace(/[^\w.-]+/g, "_")
		.replace(/^[_\.]+/, "")
}
